import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HaritaView.vue'

const routes = [
  {
    path: '/',
    name: 'haritahome',
    component: HomeView
  },
  {
    path: '/harita',
    name: 'harita',
    component: () => import(/* webpackChunkName: "about" */ '../views/HaritaView.vue')
  },
  {
    path: '/gezi-rotalari/:rota',
    name: 'gezi',
    component: () => import(/* webpackChunkName: "about" */ '../views/GeziHaritaView.vue')
  }
  ,
  {
    path: '/:detay/:adaid/:seoname',
    name: 'detay',
    component: () => import('../views/DetayView.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
